
function Icons({image}) {
    return (
        <>
            <img src={image} Style="width: 50px" />
        </>
    )
}

export default Icons